
import { Button, Typography } from "@mui/material";
import React, { useState } from "react"
import RemoveIcon from '@mui/icons-material/RemoveCircle';

export const ArrayProperty = ({ label = 'Label', onChange, inputElement, value = [] }) => {

    const [ values, setValues ] = useState(value);

    const handleChange = ix => e => {
        values[ix] = e.target.value;
        setValues([...values]);
        onChange?.(values);
    }

    const handleAdd = () => {
        const temp = [...values];
        temp.push('');
        setValues(temp);
    }

    const handleRemove = ix => () => {
        values.splice(ix, 1);
        const temp = [...values];
        setValues(temp);
    }

    return (
        <div>
            <Typography variant="h6">{label}</Typography>
            {values.map((v, ix) => {
                return (<div key={ix}><RemoveIcon onClick={handleRemove(ix)} />{ix}{React.cloneElement(inputElement, { onChange: handleChange(ix), value: values[ix] })}</div>)
            })}
            <Button onClick={handleAdd}>Add</Button>
        </div>
    )
}